import React, { useEffect, useState } from "react";
import { userManager } from "./oidc-client";

// ✅ Sabit URL'ler
const AUTHORITY = "https://auth-dev.nartio.com";
const USERINFO_URL = `${AUTHORITY}/connect/userinfo`;
const API_URL = `https://api-dev.nartio.com/app-api/sample-entity/123`;

export default function App() {
  const [user, setUser] = useState<any>(null);
  const [userInfo, setUserInfo] = useState<any>(null);
  const [decodedToken, setDecodedToken] = useState<any>(null);
  const [permissions, setPermissions] = useState<string[]>([]);
  const [apiResult, setApiResult] = useState<any>(null);
  const [apiLoading, setApiLoading] = useState<boolean>(false);

  useEffect(() => {
    userManager.getUser().then(async (u) => {
      if (u && !u.expired) {
        setUser(u.profile);

        // Access Token decode
        try {
          const parts = u.access_token.split(".");
          if (parts.length === 3) {
            const payloadJson = JSON.parse(atob(parts[1]));
            setDecodedToken(payloadJson);

            const perms = payloadJson.permissions;
            const normalized = Array.isArray(perms) ? perms : perms ? [perms] : [];
            setPermissions(normalized);
          }
        } catch (err) {
          console.error("❌ Access Token decode hatası:", err);
        }

        // UserInfo endpoint
        try {
          const res = await fetch(USERINFO_URL, {
            headers: {
              Authorization: `Bearer ${u.access_token}`,
            },
          });

          if (!res.ok) throw new Error(`UserInfo fetch failed: ${res.status}`);

          const userInfoData = await res.json();
          setUserInfo(userInfoData);
        } catch (err) {
          console.error("❌ Error fetching userinfo:", err);
        }
      }
    });
  }, []);

  const login = () => userManager.signinRedirect();
  const logout = () => userManager.signoutRedirect();

  const callApi = async () => {
    setApiLoading(true);
    setApiResult(null);

    const u = await userManager.getUser();
    if (!u || u.expired) {
      setApiResult({ error: "Kullanıcı oturumu süresi dolmuş." });
      setApiLoading(false);
      return;
    }

    try {
      const res = await fetch(API_URL, {
        headers: {
          Authorization: `Bearer ${u.access_token}`,
        },
      });

      const json = await res.json();
      setApiResult(json);
    } catch (err: any) {
      setApiResult({ error: err.message || "İstek sırasında hata oluştu." });
    } finally {
      setApiLoading(false);
    }
  };

  return (
    <div style={{ fontFamily: "Arial", padding: 20 }}>
      <h1>React SPA - Basit Login</h1>

      {user ? (
        <>
          <p><strong>Subject:</strong> {user.sub}</p>
          <button onClick={logout}>Çıkış Yap</button>

          {userInfo && (
            <div style={{ marginTop: 20 }}>
              <h3>Kullanıcı Bilgileri (UserInfo)</h3>
              <table border={1} cellPadding={5}>
                <tbody>
                  <tr>
                    <td><strong>Id</strong></td>
                    <td>{userInfo.sub}</td>
                  </tr>
                  <tr>
                    <td><strong>Email</strong></td>
                    <td>{userInfo.email}</td>
                  </tr>
                  <tr>
                    <td><strong>Roller</strong></td>
                    <td>
                      <ul>
                        {(Array.isArray(userInfo.role) ? userInfo.role : [userInfo.role]).map((r: string, idx: number) => (
                          <li key={idx}>{r}</li>
                        ))}
                      </ul>
                    </td>
                  </tr>
                  <tr>
                    <td><strong>İzinler (permissions)</strong></td>
                    <td>
                      {permissions.length > 0 ? (
                        <ul>
                          {permissions.map((p, i) => (
                            <li key={i}>{p}</li>
                          ))}
                        </ul>
                      ) : (
                        <em>Yok</em>
                      )}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          )}

          {decodedToken && (
            <div style={{ marginTop: 30 }}>
              <h3>🔍 Access Token (Decoded)</h3>
              <pre style={{ background: "#f0f0f0", padding: 10 }}>
                {JSON.stringify(decodedToken, null, 2)}
              </pre>
            </div>
          )}

          {/* 🔽 API Çağrısı Bölümü */}
          <div style={{ marginTop: 40 }}>
            <h3>🔗 API Çağrısı</h3>
            <button onClick={callApi}>API Çağır</button>
            <div style={{ marginTop: 15 }}>
              {apiLoading ? (
                <em>⏳ Bekleyiniz...</em>
              ) : apiResult ? (
                <pre style={{ background: "#f0f0f0", padding: 10 }}>
                  {JSON.stringify(apiResult, null, 2)}
                </pre>
              ) : (
                <em>Henüz çağrılmadı.</em>
              )}
            </div>
          </div>
        </>
      ) : (
        <button onClick={login}>Giriş Yap</button>
      )}
    </div>
  );
}
